import {Mapper} from '@s-ui/domain'

export class RawParamsToGetSimulatedInstantOfferRequestSellerMapper extends Mapper {
  constructor({config, getSimulatedInstantOfferRequestFactory}) {
    super()

    this._config = config
    this._DEALER_TYPES = this._config.get('dealer').DEALER_TYPES
    this._getSimulatedInstantOfferRequestFactory = getSimulatedInstantOfferRequestFactory
  }

  map = requestFields => {
    const {
      bodyTypeDoors,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      postalCode,
      transmissionTypeId,
      versionId,
      versionName,
      year
    } = requestFields

    return this._getSimulatedInstantOfferRequestFactory({
      bodyTypeDoors,
      dealerType: this._DEALER_TYPES.ALL,
      fuelId: Number(fuelId),
      makeId: Number(makeId),
      makeName,
      mileage: Number(km),
      modelId: Number(modelId),
      modelName,
      postalCode: String(postalCode).padStart(5, '0'),
      transmissionTypeId: Number(transmissionTypeId),
      versionId: Number(versionId),
      versionName,
      year: Number(year)
    })
  }
}
